var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiaWorks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.8 48",
    style: {
      enableBackground: "new 0 0 120.8 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000124161336364565537150000007485620665847410091_",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "layer_x5F_1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "layer_x5F_2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "layer_x5F_3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "layer_x5F_4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "backline"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "oreange"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dots_00000026147700210023292030000007095624211614629561_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.1,46.7l-10.4-25H14.2l-8.9,25h5.1V48H0v-1.3h3.2L20.6,0h5.6l17.1,46.7h3.1V48H24.2v-1.3H38.1z  M21.2,2.4l-6.4,17.8h12.3L21.2,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.6,46.7l-10.4-25H88.7l-8.9,25h5.1V48H74.5v-1.3h3.2L95,0h5.6l17.1,46.7h3.1V48H98.6v-1.3H112.6z  M95.7,2.4l-6.4,17.8h12.3L95.7,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.1,0.4h20.7v1.3h-9.2v45h9.2V48H49.1v-1.3h8v-45h-8V0.4z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiaWorks);
export default __webpack_public_path__ + "static/media/AIA_Works.2cf184a18c7783beaefd73319540549f.svg";
export { ForwardRef as ReactComponent };